import { Avatar } from "shared/components/Avatar";
import { Card } from "shared/components/Card";
import { RotationUser } from "./types";

const PAUSE_REASON_LABELS: Record<string, string> = {
  day_off: "a day off",
  availability_override: "an availability override",
  blocked_day: "a blocked day"
};

const getPauseReasonLabel = (reason: string | null): string => {
  if (reason && PAUSE_REASON_LABELS[reason]) return PAUSE_REASON_LABELS[reason];

  return "an availability override";
};

interface PausedRotationUserCardProps {
  user: RotationUser;
}

export const PausedRotationUserCard = ({
  user
}: PausedRotationUserCardProps) => {
  return (
    <Card className="flex items-center gap-3 md:gap-4 p-3 md:p-4">
      <div className="shrink-0 pr-3 md:pr-4 border-r border-alpha-40 h-6 w-10" />

      <Avatar
        name={user.name}
        size={40}
        fallbackBackgroundColor="rgba(28,29,34,0.08)"
        fallbackTextColor="#8b8d97"
      />

      <div className="min-w-0 flex-1">
        <span className="text-sm font-medium text-content-300 truncate">
          {user.name}
        </span>
        <p className="mt-2 text-sm text-content-200">
          Paused from rotation due to {getPauseReasonLabel(user.pause_reason)}
        </p>
      </div>
    </Card>
  );
};
